import React from 'react';
import { motion } from 'framer-motion';

const Introduction = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center max-w-4xl mx-auto"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8">
            Your Silent Partner in Digital Brand Control
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed mb-8">
            Namvoro helps modern businesses secure, streamline, and scale their digital presence. From domain portfolios and DNS to email security and cybersecurity solutions — we ensure your brand stays protected, online and everywhere it matters.
          </p>
          <div className="grid md:grid-cols-3 gap-8 mt-16">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-emerald-600">24/7</span>
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2">Always Protected</h3>
              <p className="text-slate-600">Continuous monitoring and protection for your digital assets.</p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-emerald-600">99.9%</span>
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2">Uptime Guarantee</h3>
              <p className="text-slate-600">Enterprise-grade reliability you can count on.</p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-emerald-600">∞</span>
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2">Unlimited Scale</h3>
              <p className="text-slate-600">Grow your digital presence without limitations.</p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Introduction;